// app entry
import '@@/core/polyfill'


import('./bootstrap');

// generated at 2026/6/24 11:17:33 by sui v3.1.117